/* Nano Protection — interactions des sections np-* (onglets, carrousels) */
(function () {
  if (window.__npLoaded) return;
  window.__npLoaded = true;

  function initTabs(root) {
    root.querySelectorAll('[data-np-tabs]').forEach(function (wrap) {
      if (wrap.__npInit) return;
      wrap.__npInit = true;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-np-tab]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-np-panel]'));

      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        if (focus && tabs[i]) tabs[i].focus();
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-np-carousel]').forEach(function (c) {
      if (c.__npInit) return;
      c.__npInit = true;
      var track = c.querySelector('[data-np-track]');
      var prev = c.querySelector('[data-np-prev]');
      var next = c.querySelector('[data-np-next]');
      var dots = c.querySelector('[data-np-dots]');
      if (!track) return;
      var timer;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth || 1;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function pageCount() {
        var extra = track.scrollWidth - track.clientWidth;
        return extra <= 2 ? 1 : Math.round(extra / step()) + 1;
      }
      function current() { return Math.round(track.scrollLeft / step()); }
      function goTo(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }

      function render() {
        var n = pageCount();
        if (prev) prev.disabled = n < 2;
        if (next) next.disabled = n < 2;
        if (!dots) return;
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            (function (k) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'np-dot';
              b.setAttribute('aria-label', 'Aller à la diapositive ' + (k + 1));
              b.addEventListener('click', function () { goTo(k); });
              dots.appendChild(b);
            })(i);
          }
        }
        var cur = Math.min(current(), n - 1);
        Array.prototype.forEach.call(dots.children, function (d, i) {
          d.classList.toggle('is-active', i === cur);
        });
        dots.hidden = n < 2;
      }

      if (prev) prev.addEventListener('click', function () {
        var i = current();
        goTo(i <= 0 ? pageCount() - 1 : i - 1);
      });
      if (next) next.addEventListener('click', function () {
        var i = current();
        goTo(i >= pageCount() - 1 ? 0 : i + 1);
      });
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(render, 60);
      }, { passive: true });
      window.addEventListener('resize', render);
      render();
    });
  }

  /* Apparition au défilement : les éléments .np-rv montent depuis le bas */
  var io = null;
  function initReveal(root) {
    var html = document.documentElement;
    if (!html.classList.contains('np-anim')) return;
    html.classList.add('np-anim-ready');
    var els = root.querySelectorAll('[data-np-anim] .np-rv:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    els.forEach(function (el) {
      /* Déjà dépassé (retour arrière, ancre) : afficher sans attendre */
      if (el.getBoundingClientRect().bottom < 0) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* Vidéo : l'iframe n'est chargée qu'au clic (page plus rapide) */
  function initVideos(root) {
    root.querySelectorAll('[data-np-video]').forEach(function (v) {
      if (v.__npInit) return;
      v.__npInit = true;
      var btn = v.querySelector('.np-video__play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = v.getAttribute('data-id');
        var type = v.getAttribute('data-type');
        if (!id) return;
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
          : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        var f = document.createElement('iframe');
        f.src = src;
        f.title = v.getAttribute('data-title') || 'Vidéo';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.className = 'np-video__iframe';
        v.appendChild(f);
        v.classList.add('is-playing');
        f.focus();
      });
    });
  }

  /* Sommaire d'article : construit à partir des titres H2 du texte */
  function slug(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
  }
  function initToc(root) {
    root.querySelectorAll('[data-np-toc]').forEach(function (toc) {
      if (toc.__npInit) return;
      toc.__npInit = true;
      var body = document.querySelector('[data-np-article]');
      var list = toc.querySelector('[data-np-toc-list]');
      if (!body || !list) return;
      var heads = body.querySelectorAll('h2');
      if (heads.length < 2) return;
      var used = {};
      var links = [];
      heads.forEach(function (h, i) {
        var id = h.id || slug(h.textContent);
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id += '-' + (i + 1);
        used[id] = true;
        h.id = id;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = (i < 9 ? '0' : '') + (i + 1) + ' — ' + h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });
      toc.hidden = false;
      if ('IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            links.forEach(function (l) {
              var on = l.getAttribute('href') === '#' + en.target.id;
              l.classList.toggle('is-active', on);
              if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        heads.forEach(function (h) { io2.observe(h); });
      }
    });
  }

  function init(root) {
    initToc(root || document);
    initVideos(root || document);
    initTabs(root || document);
    initCarousels(root || document);
    initReveal(root || document);
  }

  if (document.readyState !== 'loading') init(document);
  document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* Éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.hasAttribute && el.hasAttribute('data-np-tab')) el.click();
    var card = el && el.closest && el.closest('[data-np-track] > *');
    if (card) card.parentNode.scrollTo({ left: card.offsetLeft - card.parentNode.offsetLeft, behavior: 'smooth' });
  });
})();